import { Component, Event, EventEmitter, Prop, h } from '@stencil/core';

@Component({
  tag: 'biel-suggested-questions',
  styleUrl: 'biel-suggested-questions.css',
  shadow: true,
})
export class BielSuggestedQuestions {
  @Prop() heading: string = 'Suggested questions';
  @Prop() questions: string[] = [];
  @Prop() bielId: string;

  @Event() suggestedQuestionClick: EventEmitter<{ bielId: string; message: string }>;
  @Event() scrollToBottom: EventEmitter<{ bielId: string }>;

  handleQuestionClick(question: string) {
    this.suggestedQuestionClick.emit({ bielId: this.bielId, message: question });
    this.scrollToBottom.emit({ bielId: this.bielId });
  }

  render() {
    return (
      <div class="biel-suggested-questions">
        <span class="biel-suggested-questions-title">{this.heading}</span>
        <div class="biel-suggested-questions-list">
          {this.questions.map((question) => (
            <button
              class="biel-suggested-question"
              onClick={() => this.handleQuestionClick(question)}
            >
              {question}
            </button>
          ))}
        </div>
      </div>
    );
  }
}
